module.exports = __webpack_public_path__ + "img/dots_gold.07711a79.png";